import { DEV } from "esm-env";
import { defineComponent, computed, watchEffect, h } from "vue";
const TODOSliceComponent = DEV ? /* @__PURE__ */ defineComponent({
  name: "TODOSliceComponent",
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const type = computed(() => {
      return "slice_type" in props.slice ? props.slice.slice_type : props.slice.type;
    });
    watchEffect(() => {
      console.warn(`[SliceZone] Could not find a component for Slice type "${type.value}"`, props.slice);
    });
    return () => {
      return h("section", {
        "data-slice-zone-todo-component": "",
        "data-slice-type": type.value
      }, [`Could not find a component for Slice type "${type.value}"`]);
    };
  }
}) : () => null;
export {
  TODOSliceComponent
};
//# sourceMappingURL=TODOSliceComponent.js.map
